import { useT } from '../../i18n/context'

export function Spinner({ className = 'h-6 w-6' }: { className?: string }) {
    const t = useT()
    return (
        <span
            className={`inline-block animate-spin rounded-full border-2 border-slate-300 dark:border-slate-600 border-t-indigo-700 dark:border-t-indigo-500 ${className}`}
            aria-label={t('common.loading')}
        />
    )
}

export function PageLoader() {
    return (
        <div className='flex min-h-[50vh] items-center justify-center'>
            <Spinner className='h-8 w-8' />
        </div>
    )
}
